<div class="pr-6 pr-96px pt-3" role="main" aria-label="RedisCacheManagement">
  <h1 class="h-1 mb-3rem-imp">{{redisCache_Header}}</h1>
  <div class="flex-display">
    <div class="width-25">
      <mat-form-field class="mb-3" appHostListenerClick>
        <mat-label>{{redisCache_applicationDropdownHeader}}</mat-label>
        <mat-select class="dropdownValue" autofocusdropdown="true" placeholder="Applications" formControlName="showApplicationdefault" [formControl]="showApplicationdefault">
          <mat-option class="dropdownValue" *ngFor="let type of applicationList" [value]="type">{{type}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="width-25">
      <mat-form-field class="mb-3" appHostListenerClick>
        <mat-label>{{redisCache_environmentDropdownHeader}}</mat-label>
        <mat-select class="dropdownValue" placeholder="Environments" formControlName="showEnvironmentdefault" [formControl]="showEnvironmentdefault">
          <mat-option class="dropdownValue" *ngFor="let type of environmentList" [value]="type">{{host}} {{type}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="ptb-1-25">
    <button mat-button class="btn-redisClear" (click)="confirmClearRedisCache()">{{redisCache_clearButton}}</button>
  </div>
  <div class="mt-2">
    <span [innerHTML]="redisCache_cleanUpText"></span>
  </div>
</div>
